import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    allowBack: '',
    orderId: '',
    menu: []
}

const getters = {
    getAllowBack (state) {
        return state.allowBack
    },
    getOrderId (state) {
        return state.orderId
    },
    getMenu (state) {
        return state.menu
    }
}
const mutations = {
    setAllowBack (state, allowBack) {
        state.allowBack = allowBack
    },
    setOrderId (state, orderId) {
        state.orderId = orderId
    },
    setMenu (state, menu) {
        state.menu = menu
    }
}

const actions = {
    allowBack ({commit}, allowBack) {
        commit('setAllowBack', allowBack)
    },
    orderId ({commit}, orderId) {
        commit('setOrderId', orderId)
    },
    menu ({commit}, menu) {
        commit('setMenu', menu)
    }
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/store/index.js